import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { LangProvider } from './lang'
import './styles.css'

const el = document.getElementById('root')
if (!el) throw new Error('no #root')

createRoot(el).render(
  <StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </StrictMode>,
)
